export const firebaseConfig = {
    apiKey: "AIzaSyCpzgDpcJcppIFytyEzFkfpWembedDJoAU",
    authDomain: "mutual-37081.firebaseapp.com",
    databaseURL: "https://mutual-37081.firebaseio.com",
    projectId: "mutual-37081",
    storageBucket: "mutual-37081.appspot.com",
    messagingSenderId: "740259366867",
    appId: "1:740259366867:web:f72ca548be25c8a8c75126",
    measurementId: "G-ZR5WXSF5VT"
};
  
  